

<template>
  <div id="app">
    
    <div class="cc-progress">
      <div class="cc-progress-bar" :class="{ 'cc-progress-bar-active': isActiveCall }">
        <span class="sr-only">60% Complete</span>
      </div>
    </div>
    
    <div class="container-fluid" style="height:calc(100% - 5px)">
      <cc-login v-if='!isloggedIn' @logout="onLogin"></cc-login>
      
      <div v-else id="cc-maske" class="row ">
        
        <div id='cc-left' class="col-xs-7">
          <company-callcenter  v-show="!isActiveCall" id="company-callcenter" class="cc-box"></company-callcenter>
          <company-client v-show="isActiveCall" id="company-client" class="cc-box"></company-client>
          <user-callcenter v-show="!isActiveCall" id="user-callcenter" class="cc-box" @logout="onClickLogout"></user-callcenter>
          <user-client v-show="isActiveCall" id="user-client" class="cc-box"></user-client>
        </div>
        
         <div id='cc-right' class="col-xs-5">
          <user-caller v-show="isActiveCall" id="user-caller" class="cc-box"></user-caller>
          <parking v-if="!isActiveCall" id="parking" class="cc-box"></parking>
          
          <message id="message" class="cc-box" v-show="true"></message>
          <history id="cc-history" class="cc-box" ></history>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>

import Bus from './common/bus'

import Login from './Login.vue'
import Status from './Status.vue'
import CompanyCallCenter from './CompanyCallCenter.vue'
import CompanyClient from './CompanyClient.vue'
import UserCallCenter from './UserCallCenter.vue'
import UserClient from './UserClient.vue'

import UserCaller from './UserCaller.vue'
import Message from './Message.vue'
import History from './History.vue'
import Parking from './Parking.vue'


  
export default {
  data () {
    return {
      bus: Bus.$data, // for Debugg
      ccProgressWidth: '0%',
      ccProgressTransition: 'none',
    }
  },
  components: {
    'cc-login': Login,
    'cc-status': Status,
    'company-callcenter': CompanyCallCenter,
    'company-client': CompanyClient,
    'user-callcenter': UserCallCenter,
    'user-client': UserClient,
    'user-caller': UserCaller,
    'message': Message,
    'history': History,
    'parking': Parking,
    
  },
  
  created: function () {
    //Bus.registerOnLogin(this.onLogin);
  },
  
  mounted: function () {
    // Wenn über URL aufgerufen werden soll /222
    // Bus.emitIdCompanyClient(751);
    // Bus.emitIdCompanyClient(0);
    
    //this.loggedIn = Bus.isLoggedIn(),
    
    // console.log('app:mounted:');

  },
  
  
  computed: {
    
    isloggedIn: function () {
      return Bus.isLoggedIn();
    },
    
    isActiveCall: function () {
      //return true;
      if(!!Bus.call.idCompanyClient){
        this.ccProgressWidth = '100%'
        this.ccProgressTransition = 'width 90s ease-out'
      }
      else{
        this.ccProgressWidth = '0%'
        this.ccProgressTransition = 'none'
      }
      
      return !!(Bus.call.idCompanyClient);
    },
    
      
  },  
  
  methods: {

    onLogin: function (loginData) {
      this.loggedIn = true;
      sessionStorage.setItem("login",JSON.stringify(loginData));
      
      
    },
    
    
    
    onClickLogout: function () {
      Bus.logout('by UserCallCenter');
    }


  }
}



</script>

<style>
  
  body, html {
      height: 100%;
  }

  /* Scollbar entfernen */
  body, html {
      /* overflow: scroll; */
      overflow-x: hidden;
  }

  ::-webkit-scrollbar {
      width: 2px;  /* remove scrollbar space */
      height: 2px;  /* remove scrollbar space */
      background: transparent;  /* optional: just make scrollbar invisible */
  }
  /* optional: show position indicator in red */
  ::-webkit-scrollbar-thumb {
      background: #003bff;
  }
  /* End Scollbar entfernen */  

  
  #app {
    background-color: #eee;
     height: 100%;
  }  
  

  #cc-maske {
    height: calc(100%);
  }

  #xxxcc-status {
    border: 1px solid lightgrey;
    box-shadow: 2px 2px 6px lightgrey;
    background-color: #FFF;
  }
  
  #cc-left, #cc-right {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: calc(100%);
    border: 0px solid red;
  }

  #cc-left {
    
    border-right: 0px solid #CCC;
    padding-right: 0;  
  }
  
  #company-client,
  #company-callcenter{
    height: calc(50%);
  }

  #user-client,
  #user-callcenter {
    height: calc(50% - 35px);
    margin-bottom: 15px;
  }

  #parking,
  #user-caller  {
    height: calc(45%);
  }

  #message  {
    height: calc(30%);
  }

  #cc-history  {
    height: calc(28%);
    margin-bottom: 15px;
  }

  .cc-box{
    border: 1px solid lightgrey;
    box-shadow: 2px 2px 6px lightgrey;
    background-color: #FFF;
    padding: 10px;
    margin-top: 10px;
    
  }  
  
  .cc-progress {
    height: 5px;
    overflow: hidden;
  }
  
  .cc-progress-bar {
    float: left;
    width: 0;
    transition: all 2s;
    height: 100%;
    background-color: #337ab7;
  }
  .cc-progress-bar-active{
    width: 100%;
    background-color: red;
    transition: width 90s ease-out, background-color 10s linear 60s;
  }
  
</style>



// WEBPACK FOOTER //
// App.vue?70a0f7fc